<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <textarea class="form-control" rows="2" v-model="note"></textarea>
      </div>
    </div>
    <div
      class="row mt-2 d-flex align-items-center justify-content-around"
      v-if="toggle_reminder"
    >
      <div class="col d-flex justify-content-around">
        <span class="badge rounded-pill bg-primary" @click="setDate('day')"
          >1d</span
        >
        <span class="badge rounded-pill bg-primary" @click="setDate('week')"
          >1w</span
        >
        <span class="badge rounded-pill bg-primary" @click="setDate('month')"
          >1m</span
        >
        <i
          class="bi bi-x-lg text-danger"
          @click="clearDate()"
          v-if="reminder_date"
        ></i>
      </div>
      <div class="col">
        <input
          type="date"
          id="reminder_date"
          class="form-control date-field me2"
          placeholder="Date"
          :value="reminder_date"
          @change="updateReminderDate()"
        />
      </div>
    </div>
    <div class="row mt-2 mb-2 d-flex align-items-center justify-content-around">
      <div class="col d-flex justify-content-center">
        <input
          type="date"
          id="txn_date"
          class="form-control date-field me2"
          placeholder="Date"
          :value="txn_date"
          @change="updateDate()"
        />
      </div>
      <div class="col d-flex justify-content-center">
        <i class="bi bi-camera"></i>
      </div>
      <div class="col d-flex justify-content-center">
        <i class="bi bi-bell" @click="toggleReminder()"></i>
      </div>
      <div class="col d-flex justify-content-center">
        <button class="btn btn-sm btn-success" @click="updateNote()">
          Edit
        </button>
      </div>
    </div>
  </div>
</template>
<script setup>
import { defineProps, onMounted, ref, defineEmits } from "vue";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase/config";
const props = defineProps(["note"]);
const emits = defineEmits(["noteEdited"]);
const dayjs = require("dayjs");
const note = ref("");
const reminder_date = ref("");
const txn_date = ref("");
const toggle_reminder = ref(false);
onMounted(() => {
  populateData();
});
const populateData = () => {
  note.value = props.note.n;
  reminder_date.value = props.note.r.split(" ")[0];
  txn_date.value = props.note.d.split(" ")[0];
};
const updateReminderDate = () => {
  reminder_date.value = document.getElementById("reminder_date").value.trim();
};
const toggleReminder = () => {
  toggle_reminder.value = !toggle_reminder.value;
};
const updateDate = () => {
  txn_date.value = document.getElementById("txn_date").value.trim();
};
const setDate = (timeframe) => {
  if (!reminder_date.value) {
    reminder_date.value = dayjs().format("YYYY-MM-DD");
  }
  switch (timeframe) {
    case "day":
      reminder_date.value = dayjs(reminder_date.value)
        .add(1, "day")
        .format("YYYY-MM-DD");
      break;
    case "week":
      reminder_date.value = dayjs(reminder_date.value)
        .add(1, "week")
        .format("YYYY-MM-DD");
      break;
    case "month":
      reminder_date.value = dayjs(reminder_date.value)
        .add(1, "month")
        .format("YYYY-MM-DD");
      break;
    default:
      reminder_date.value = null;
  }
};
const clearDate = () => {
  reminder_date.value = "";
};
const updateNote = async () => {
  const noteRef = doc(db, "notes", props.note.account_id);
  var noteObj = {
    n: note.value, //note
    r: reminder_date.value, //reminder date - after which reminder should show
    p: null, //link to photo, if any
    d: txn_date.value + " " + dayjs().format("HH:mm:ss"),
  };
  await updateDoc(noteRef, {
    ["journal." + props.note.journal_id]: noteObj,
  });
  setTimeout(() => {
    emits("noteEdited");
  }, 1000);
};
</script>
